import * as React from 'react';
import { isEmpty } from 'ramda';
import ObjectTableRow from './ObjectTableRow';
import { IColumnDef } from '../../../../../../Types/ColumnDefType';
import EDTableCell from '../../../../../../BaseComponents/Table/Components/EDTableCell';
import EDTable from '../../../../../../BaseComponents/Table/EDTable';
import EDTableHead from '../../../../../../BaseComponents/Table/Components/EDTableHead';
import EDTableRow from '../../../../../../BaseComponents/Table/Components/EDTableRow';
import EDTableBody from '../../../../../../BaseComponents/Table/Components/EDTableBody';

interface IProps {
  columns: IColumnDef[];
  readonly data: Array<{ id: string }> | null;
  selectedId?: string | null;
  selectDetail?: (id: string | null, index?: number) => void;
}

const noColumns: IColumnDef[] = [];
/**
Visar en tabell med en lista av objekt som indata.

Kan användas direkt för data som skapas på klienten, men framförallt en grundkomponent för att skapa andra tabeller som t.ex. är kopplade till modelldata
*/
class ObjectTable extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
    this.handleCellClick = this.handleCellClick.bind(this);
  }

  handleCellClick(rowNumber: number) {
    if (this.props.data && this.props.selectDetail) {
      const id: string = this.props.data[rowNumber].id;
      this.props.selectDetail(id, rowNumber);
    }
  }

  handleRowClick = (rowNumber: number) => {
    if (this.props.data && this.props.selectDetail) {
      const id: string = this.props.data[rowNumber].id;
      this.props.selectDetail(id, rowNumber);
    }
  };

  render() {
    const columns = this.props.columns || noColumns;
    const data = this.props.data || [];
    const header =
      !columns || isEmpty(columns) ? (
        <EDTableCell>Inga kolumner valda</EDTableCell>
      ) : (
        columns.map(column => (
          <EDTableCell key={column.attributeDef}>{column.caption}</EDTableCell>
        ))
      );

    const rows = data.map((object, index) => (
      <ObjectTableRow
        columns={columns}
        object={object}
        key={object.id}
        selected={this.props.selectedId === object.id}
        onClick={this.handleRowClick}
        rowNumber={index}
      />
    ));

    return (
      <EDTable>
        <EDTableHead>
          <EDTableRow>{header}</EDTableRow>
        </EDTableHead>
        <EDTableBody>{rows}</EDTableBody>
      </EDTable>
    );
  }
}

export default ObjectTable;
